<template>
  <v-container fluid fill-height>
    <v-layout
      justify-center
      align-center
    >
      <v-flex xs7 md5>
        <v-card class="elevation-1">
          <v-toolbar color="primary">
            <v-btn icon class="white--text" @click="goBack">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text">Create Admin</v-toolbar-title>
          </v-toolbar>
              <v-card-title>
                <v-container fluid>
                  <v-layout row>
                    <v-flex xs4>
                      <v-subheader>First Name:</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        name="input-1"
                        v-model="admin.user.first_name"
                        label="First Name"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs4>
                      <v-subheader>Last Name:</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        name="input-1"
                        v-model="admin.user.last_name"
                        label="Last Name"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs4>
                      <v-subheader>Email</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        name="input-1"
                        v-model="admin.user.email"
                        label="Email"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs4>
                      <v-subheader>Password</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        name="input-10-1"
                        label="Password"
                        v-model="admin.user.password"
                        :append-icon="e1 ? 'visibility' : 'visibility_off'"
                        :append-icon-cb="() => (e1 = !e1)"
                        :type="e1 ? 'password' : 'text'"
                        counter
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-card-actions>
                    <v-btn color="primary" @click.prevent="post"
                    >Create</v-btn>
                  </v-card-actions>
                </v-container>
            </v-card-title>
        </v-card>
      </v-flex>
      <div>
        <v-alert
          color="error"
          icon="warning"
          :value="alert"
          transition="scale-transition"
        >
          User with the same email adress already exist.
        </v-alert>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      admin: {
          "user": {
              "email": "",
              "first_name": "",
              "last_name": "",
              "password": "",
              "is_admin": "1",
              "approved": "1"
          }
      },
      alert: false,
      e1: true
    };
  },
  methods: {
    errorAlert() {
      this.alert = !this.alert;
      setTimeout(() => {
          this.alert = !this.alert;
      }, 2500);
    },
    goBack(){
      this.$router.push("/admin/admins");
    },
    post() {
      axios.post("/users", this.admin)
      .then(res => {
        this.$router.push("/admin/admins");
        this.goBack();
        this.errorAlert();
      })
      .catch(error => {
          this.errorAlert();
      });
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/Admins/AdminsNew.vue